import { Component, Input } from '@angular/core';
import {
  clockIcon,
  calendarIcon,
  playIcon,
  categoryIcon,
  bookmarkIcon,
} from '../../../app-icons';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { TrainerModel } from 'src/app/models/trainer.model';

@Component({
  selector: 'app-training-card',
  templateUrl: './training-card.component.html',
  styleUrls: ['./training-card.component.scss'],
  standalone: false
})
export class TrainingCardComponent {
  @Input()
  training!: any;

  @Input()
  isCatalogue: boolean = false;

  @Input()
  isLearningPath: boolean = false;

  @Input()
  isNew: boolean = false;

  @Input()
  categoryId: string = '';

  @Input()
  learningPathId: string = '';

  @Input()
  isLocked: boolean = false;

  @Input()
  trainers: TrainerModel[] = [];

  get imageUrl(): string | null {
    return this.training.customImageFile?.fileUrl
      ?? this.training.imageFile?.fileUrl
      ?? this.training.customImageUrl
      ?? this.training.imageUrl
      ?? null;
  }

  getCategoryIcon() {
    return this.sanitized.bypassSecurityTrustHtml(categoryIcon);
  }

  getClockIcon() {
    return this.sanitized.bypassSecurityTrustHtml(clockIcon);
  }

  getCalendarIcon() {
    return this.sanitized.bypassSecurityTrustHtml(calendarIcon);
  }

  getPlayIcon() {
    return this.sanitized.bypassSecurityTrustHtml(playIcon);
  }

  getBookmarkIcon() {
    return this.sanitized.bypassSecurityTrustHtml(bookmarkIcon);
  }

  shouldDisableLink(): boolean {
    return this.training.status === 3 && this.isLearningPath;
  }

  getCardLink(): { commands: any[]; queryParams?: any } {
    let commands: any[] = [];
    let queryParams: any = undefined;

    if (this.isCatalogue) {
      commands = [
        '/training-catalogue',
        this.categoryId,
        this.training.type.toLowerCase(),
        this.training.id,
      ];
    } else {
      commands = [
        '/my-trainings',
        this.isLearningPath ? 'course' : this.training.type.toLowerCase(),
        this.isLearningPath ? this.training.eventId : this.training.id,
      ];
      if (this.isLearningPath) {
        queryParams = { learningPathId: this.learningPathId };
      }
    }

    return { commands, queryParams };
  }

  readonly maxTrainersToShow = 2;

  constructor(
    private sanitized: DomSanitizer,
    public translateService: TranslateService
  ) {}
}
